import axios from "axios";
import { toast } from "react-toastify";
import { REACT_API_URL } from "../ENV";
import storage from "../context/helper";

const Axios = axios.create({
  headers: {
    Accept: "application/json,application/x-www-form-urlencoded,text/plain,*/*",
    "Content-Type": "application/json;charset=utf-8",
  },
});

// Add a response interceptor
Axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const stateCode = error.response?.status;
    if (stateCode === 401) {
      let message = error.response.data.message || error.response.data.error || "Auth Failed";
      message = `error: ${message}`;
      toast.error(message);

      // Kocek returns 401 when the customer's login has expired: log out and send them to log in again
      if ((error.config?.url || "").startsWith(REACT_API_URL)) {
        localStorage.removeItem(storage.USER_TOKEN_KEY);
        localStorage.removeItem(storage.USER_DETAILS_KEY);
        window.location.assign("/login");
      }
    }
    return Promise.reject(error);
  }
);

export default Axios;
